export enum StringComparer {
	CaseSensitive,
	CaseInSensitive
}
